import React, {Component, Fragment} from 'react';
import {Provider} from 'react-redux';
import {Link, Redirect, Route, Switch, withRouter} from 'react-router-dom';
import {compose} from "recompose";

import {createMuiTheme} from '@material-ui/core/styles';
import {withStyles} from "@material-ui/core/styles/index";
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import DashboardIcon from '@material-ui/icons/Dashboard';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import DomainIcon from '@material-ui/icons/Domain';
import PeopleIcon from '@material-ui/icons/People';
import Snackbar from '@material-ui/core/Snackbar';

import MomentUtils from 'material-ui-pickers/utils/moment-utils';
import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider';

import {isAdministrator, isAuthenticated} from './helpers/auth.helper';
import {PrivateRoute} from './components/PrivateRoute';
import Dashboard from './components/Dashboard';
import Empresa from './components/Empresa';
import Header from './components/Header';
import LoginForm from './components/LoginForm';
import Logout from './components/Logout';
import Usuario from './components/Usuario';

import configureStore from './store';

const store = configureStore();

const defaultTheme = createMuiTheme();

const styles = {
    profile: {
        width: 250,
        height: 120,
    },
};

class App extends Component {

    constructor(props) {
        super(props);

        this.state = {
            drawer: {
                open: false
            }
        };
    }

    handleDrawerToggle() {
        let drawer = {...this.state.drawer};
        drawer.open = !this.state.drawer.open;
        this.setState({drawer});
    };

    render() {
        return (
            <Provider store={store}>
                <MuiThemeProvider theme={defaultTheme}>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                        {isAuthenticated()
                            ? <Fragment>
                                <Header onToggle={() => this.handleDrawerToggle()} className={'app-bar ' + (this.state.drawer.open ? 'expanded' : '')}/>

                                <Drawer open={this.state.drawer.open} onClose={this.handleDrawerToggle.bind(this)}>
                                    <Card>
                                        <CardMedia className={this.props.classes.profile} image="img/profile_background.jpg"/>
                                    </Card>
                                    <List>
                                        <ListItem button component={Link} to={'/dashboard'} onClick={this.handleDrawerToggle.bind(this)}>
                                            <ListItemIcon>
                                                <DashboardIcon/>
                                            </ListItemIcon>
                                            <ListItemText primary="Dashboard"/>
                                        </ListItem>
                                        {isAdministrator() ?
                                            <Fragment>
                                                <ListItem button component={Link} to={'/companies'} onClick={this.handleDrawerToggle.bind(this)}>
                                                    <ListItemIcon>
                                                        <DomainIcon/>
                                                    </ListItemIcon>
                                                    <ListItemText primary="Empresas"/>
                                                </ListItem>
                                                <ListItem button component={Link} to={'/users'} onClick={this.handleDrawerToggle.bind(this)}>
                                                    <ListItemIcon>
                                                        <PeopleIcon/>
                                                    </ListItemIcon>
                                                    <ListItemText primary="Usuários"/>
                                                </ListItem>
                                            </Fragment>
                                            : null
                                        }
                                    </List>
                                </Drawer>
                            </Fragment>
                            : null
                        }

                        <div className={'app-content ' + (this.state.drawer.open ? 'expanded' : '')}>
                            <Switch>
                                <PrivateRoute exact path='/dashboard' component={Dashboard}/>
                                <PrivateRoute exact path='/users' component={Usuario}/>
                                <PrivateRoute exact path='/companies' component={Empresa}/>
                                <Route path='/login' component={LoginForm}/>
                                <Route path='/logout' component={Logout}/>
                                <Redirect from='*' to='/dashboard'/>
                            </Switch>
                        </div>
                        <Snackbar autoHideDuration={5000} open={false} message={''}/>
                    </MuiPickersUtilsProvider>
                </MuiThemeProvider>
            </Provider>
        );
    }
}

export default compose(
    withStyles(styles, {name: 'App'}),
    withRouter
)(App);


// WEBPACK FOOTER //
// src/App.js